import React, { useRef } from "react";
import Autocomplete from "react-google-autocomplete";

type BaseAddressSelectProp = {
    styleClass: string;
    disabled?: boolean;
    label: string;
    id: string;
    value: string;
    hasError?: boolean;
    onSelect: (place: any) => void;
    change?: () => void;
    errorMsg: string;
};

const BaseAddressSelect: React.FC<BaseAddressSelectProp> = ({
    styleClass = "",
    disabled = false,
    label,
    id,
    value,
    hasError = false,
    onSelect,
    change,
    errorMsg = ""
}) => {
    const inputRef = useRef(null);

    return (
        <>
            <div className="fieldset relative">
                <label
                    htmlFor={id}
                    className="absolute pl-2 text-[14px] text-[#767B86] font-[500] dark:text-[#575A65] duration-300 transform -translate-y-[0.6rem] scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-[#575A65] peer-focus:dark:text-[#575A65] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[0.6rem]"
                >
                    {label}
                </label>
                <Autocomplete
                    style={{ height: "56px", width: "100%" }}
                    id={id}
                    options={{
                        types: ["geocode"],
                        componentRestrictions: {
                            country: ["ng"]
                        },
                    }}
                    ref={inputRef}
                    className={`${styleClass} rounded-lg !bg-[#F9FAFC] px-4 h-[56px] pb-2.5 pt-5 w-full text-md text-[#2D2D31] ${
                        !value ? "bg-[#F9FAFC] dark:bg-[#F9FAFC]" : "bg-white"
                    } border border-[#E5E9F2] appearance-none dark:text-[#2D2D31] dark:border-[#E5E9F2] dark:focus:border-[#A0A1B9] 
                    focus:outline-none not:empty:bg-white active:bg-white focus:rounded-md focus:ring-0 focus:border-[#A0A1B9] ${
                        hasError &&
                        "border border-[#F85359] dark:border-[#F85359]"
                    } ${disabled && "border-[#A0A1B9] opacity-50 cursor-not-allowed"}`}
                    defaultValue={value}
                    apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                    onPlaceSelected={(place) => onSelect(place)}
                    onChange={change}
                    
                />
                {hasError && (
                    <p className="text-[#F85359] text-[12px] pt-1">
                        {errorMsg}
                    </p>
                )}
            </div>
        </>
    );
};

export default BaseAddressSelect;
